import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
} from '@backstage/theme';
import {
  essityBrand,
  essityStatus,
  essityStatusInfo,
  essityStatusSurface,
  essityUiTones,
} from './colours';
import { createEssityComponents } from './components';
import { createEssityPageTheme } from './essityPageTheme';
import { essityFontFamily, essityTypography } from './typography';

export const lightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: { main: essityBrand.navy },
      secondary: { main: essityUiTones.pinkOnLight },
      error: { main: essityStatus.error },
      warning: { main: essityStatus.warning },
      info: { main: essityStatusInfo.light },
      success: { main: essityStatus.success },
      background: { default: essityBrand.neutral, paper: essityBrand.white },
      link: essityUiTones.pinkOnLight,
      linkHover: essityBrand.navy,
      banner: {
        info: essityBrand.navy,
        error: essityStatus.error,
        text: essityBrand.white,
        link: essityUiTones.pinkOnDark,
      },
      errorBackground: essityStatusSurface.light.error,
      warningBackground: essityStatusSurface.light.warning,
      infoBackground: essityStatusSurface.light.info,
      navigation: {
        background: essityBrand.white,
        indicator: essityBrand.pink,
        color: essityBrand.navy,
        selectedColor: essityUiTones.pinkOnLight,
        navItem: { hoverBackground: essityUiTones.pinkTint },
        submenu: { background: essityBrand.neutral },
      },
    },
    typography: essityTypography,
  }),
  defaultPageTheme: 'home',
  fontFamily: essityFontFamily,
  components: createEssityComponents(essityBrand.border),
  pageTheme: { home: createEssityPageTheme(essityBrand.navy) },
});
